import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpProvider } from '../../../../types/types';

const initialState:any ={}

const selectedTopUpProvider = createSlice({
  name: 'selectedTopUpProvider',
  initialState,
  reducers: {
    setSeletedTopUpProvider(state,action:PayloadAction<TopUpProvider>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default selectedTopUpProvider.reducer;

// Actions
export const {setSeletedTopUpProvider} = selectedTopUpProvider.actions;

